import React from 'react'
import link from '../../../assets/icons/link 16@2x.png'

export default function LinkButton() {
  return (
    <div style={styles.container}>
      <img src={link} style={{ width: 14, height: 14 }} />
    </div>
  )
}

const styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: 36,
    border: '1px solid #E6E6E6',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 'auto',
  },
}
